import React from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function OutlinedButton({ onClick, children, disabled, width, className }) {
  return (
    <button
      className={classNames(classes.OutlinedButton, className, {
        [classes.disabled]: disabled,
      })}
      type="button"
      onClick={onClick}
      style={{ width }}
    >
      {children}
    </button>
  );
}
